import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import { actions } from "../../../../Redux";
import Headerbar from "../../../Components/InnerLayout/Headerbar";
import UserInterface from "../../../Components/InnerLayout/UserInterface";
const Integrations = (params) => {
  const dispatch = useDispatch();
  const history = useHistory();
  useEffect(() => {
    dispatch(actions?.getIntegrationData());
  }, []);

  const grabFoodData = useSelector(
    (state) => state?.settingReducer?.integrationData?.merchantStore?.Grabfood
  );
  return (
    <UserInterface>
      <div className="no-sidebar row" id="content">
        <Headerbar />

        <div className="inner-content row mx-0 finance-setting-chart chart-of-accounts">
          <div className="container px-0">
            <div className="shadowclass">
              <h4 className="event-alert">Online Ordering Integrations</h4>
              <div className="row justify-content-between align-items-center w-100 mx-0">
                <div className="col-lg-4 col-md-5 px-0 mb-3 mb-sm-0">
                  <div className="search-box mt-0">
                    <form type="GET">
                      <input type="text" placeholder="Search" name="keyword1" />
                      <input type="submit" />
                    </form>
                  </div>
                </div>
              </div>

              <div class="col-12 row mx-0 mt-3">
                <h4 class="event-alert text-green col-12">
                  Integration Package Status : <span>Disabled </span>{" "}
                </h4>
                <div class="merchant-row btns align_left px-0 d-flex align-items-start">
                  <button id="enable-package" class="ml-0 mr-3 py-2">
                    Enable Package
                  </button>
                  <a
                    onClick={() =>
                      history.push("/settings/integrations/api_keys_listing")
                    }
                    class="ml-0 btn green-btn-revert py-2"
                  >
                    Get GOGMGO API Keys
                  </a>
                </div>

                <div class="merchant-row btns span2 text-left ml-0"></div>
              </div>

              <div class="row-fluid">
                <ul class="package-ul">
                  <li class="package-li">
                    <div class="main-content">
                      <div class="heading-row">
                        <h4>Grabfood </h4>
                        <span class="text-green">(Active)</span>
                        <span class="text-green icon">
                          <a
                           class="circle_icon"
                            onClick={() =>
                              history.push("/settings/integrations/edit")
                            }
                          >
                            <i class="iconSprites edit-icon"></i>
                          </a>{" "}
                        </span>
                      </div>

                      <div class="content">
                        <div class="image">
                          <img
                            src="http://uat.gogmgo.com/img/grab_icon.png"
                            alt="grab-icon"
                          />{" "}
                        </div>

                        <div class="content-right">
                          <h4 class="event-alert">APIs AVAILABLE</h4>
                          <ul class="term-list">
                            <li class="yellow">Menu Master</li>
                            <li class="green">Order Acceptance</li>
                            <li class="green">Order Completion</li>
                            <li class="yellow toggleable">Promotions Master</li>
                            <li class="more-link"> See More </li>
                          </ul>
                          {grabFoodData?.status === "deactive" ? (
                            <div class="span8">
                              <p class="merchant-id">
                                <strong>Merchant ID:</strong>
                                {grabFoodData?.merchant_id}
                              </p>
                            </div>
                          ) : (
                            ""
                          )}

                          <div class="span4 ml-0">
                            <div class="btns">
                              <a
                                onClick={() => {
                                  grabFoodData?.status === "deactive"
                                    ? dispatch(
                                        actions?.postPackageStatus({
                                          id: grabFoodData?.id,
                                          status: "active",
                                        })
                                      )
                                    : dispatch(
                                        actions?.postPackageStatus({
                                          id: grabFoodData?.id,
                                          status: "deactive",
                                        })
                                      );
                                }}
                                class="btn btn_btnblue"
                              >
                                {grabFoodData?.status[0]?.toUpperCase() +
                                  grabFoodData?.status?.slice(1)}
                              </a>{" "}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </li>

                  <li class="package-li">
                    <div class="main-content">
                      <div class="heading-row">
                        <h4>Deliveroo </h4>
                      </div>

                      <div class="content">
                        <div class="image">
                          <img
                            src="http://uat.gogmgo.com/img/deliveroo_icon.png"
                            alt="deliveroo-icon"
                          />{" "}
                        </div>
                        <div class="content-right">
                          <h4 class="event-alert">APIs AVAILABLE</h4>
                          <ul class="term-list">
                            <li class="yellow">Menu Master</li>
                            <li class="green">Order Acceptance</li>
                            <li class="green">Order Completion</li>
                            <li class="yellow toggleable">Promotions Master</li>
                            <li class="more-link"> See More </li>
                          </ul>

                          <div class="merchant-row btns clear">
                            <button
                              class="btn btn_btnblack"
                              type="button"
                              disabled="disabled"
                            >
                              Coming Soon!
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </li>

                  <li class="package-li">
                    <div class="main-content">
                      <div class="heading-row">
                        <h4>FoodPanda </h4>
                      </div>

                      <div class="content">
                        <div class="image">
                          <img
                            src="http://uat.gogmgo.com/img/foodpanda_icon.png"
                            alt="foodpanda-icon"
                          />{" "}
                        </div>

                        <div class="content-right">
                          <h4 class="event-alert">APIs AVAILABLE</h4>
                          <ul class="term-list">
                            <li class="yellow">Menu Master</li>
                            <li class="green">Order Acceptance</li>
                            <li class="green">Order Completion</li>
                            <li class="yellow toggleable">Promotions Master</li>
                            <li class="more-link"> See More </li>
                          </ul>

                          <div class="merchant-row btns clear">
                            <button
                              class="btn btn_btnblack"
                              type="button"
                              disabled="disabled"
                            >
                              Coming Soon!
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </li>

                  <li class="package-li">
                    <div class="main-content">
                      <div class="heading-row">
                        <h4>Oddle </h4>{" "}
                      </div>

                      <div class="content">
                        <div class="image">
                          <img
                            src="http://uat.gogmgo.com/img/oddle_icon.png"
                            alt="oddle-icon"
                          />{" "}
                        </div>

                        <div class="content-right">
                          <h4 class="event-alert">APIs AVAILABLE</h4>
                          <ul class="term-list">
                            <li class="yellow">Menu Master</li>
                            <li class="green">Order Acceptance</li>
                            <li class="green">Order Completion</li>
                            <li class="yellow toggleable">Promotions Master</li>
                            <li class="more-link"> See More </li>
                          </ul>

                          <div class="merchant-row btns clear">
                            <button
                              class="btn btn_btnblack"
                              type="button"
                              disabled="disabled"
                            >
                              Coming Soon!
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </UserInterface>
  );
};
export default Integrations;
